import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { parseUserMetadataFromHash } from '@scouts/auth'

export const useUserMetadataFromHash = () => {
    const { hash } = useLocation()

    const userMetadata = useMemo(() => (hash ? parseUserMetadataFromHash(hash) : undefined), [hash])

    return { userMetadata }
}
